<section class="container-fluid login">
  <div class="row mt-4">
    <div class=" col-12 col-sm-12 col-md-6 d-flex flex-column">
      <div class="columna d-flex align-items-center flex-column ">
        <img src="../../../../assets/images/images/logo-cervino.png" alt="">
      </div>
      <div class="formulario ">
        <div class="row d-flex justify-content-center texto">
          <div class="padding col-12 col-sm-10 col-md-10">
            <p>Hola</p>
          </div>
          <div class="padding col-12 col-sm-10 col-md-10">
            <h1>INICIA SESIÓN</h1>
          </div>
        </div>
        <div class="row d-flex justify-content-center m-2">
          <div class="col-12 col-sm-10 col-md-10 ">
            <div class="form-floating mb-1">
              <input [(ngModel)]="loginUserRequestModel.nit" type="text" autocomplete="off" class="form-control"
                onClick="select()" tabindex="1" autofocus (keydown.enter)="asyncLoginUser(false)" />
              <label for="floatingInput" class="floating-input-edit">NIT de la empresa*</label>
            </div>
          </div>
          <div class="col-12 col-sm-10 col-md-10 mt-2">
            <div class="form-floating mb-1">
              <input [(ngModel)]="loginUserRequestModel.userName" type="text" autocomplete="off" class="form-control"
                onClick="select()" tabindex="2" (keydown.enter)="asyncLoginUser(false)" />
              <label for="floatingInput" class="floating-input-edit">Usuario*</label>
            </div>
          </div>
          <div class="col-12 col-sm-10 col-md-10 mt-2">
            <div class="form-floating mb-1">
              <input [(ngModel)]="loginUserRequestModel.password" [type]="hide ? 'password' : 'text'" autocomplete="off"
                class="form-control" onClick="select()" tabindex="3" (keydown.enter)="asyncLoginUser(false)" />
              <label for="floatingInput" class="floating-input-edit">Contraseña*</label>

              <p-button class="position-absolute top-50 end-0 translate-middle-y"
                [icon]="hide ? 'pi pi-eye' : 'pi pi-eye-slash'" [rounded]="true" [text]="true" (click)="hide = !hide"
                title="hidemostrar">
              </p-button>
            </div>
          </div>
        </div>
      </div>
      <div class="ayuda">
        <a href="https://www.altos-soft.com/" tabindex="5">¿Necesitas ayuda?</a>
      </div>
      <div class="guardar">
        <button class="btnGuardar" (click)="asyncLoginUser(false)" tabindex="4">Iniciar sesión</button>
        <button id="btnChangeSesion" (click)="asyncLoginUser(true)" hidden>Cambiar sesión</button>
      </div>
    </div>
    <div class="col-12 col-sm-12 col-md-6  d-none d-md-block derecha">
      <div class="  contenedor2 ">
        <div class="row ">
          <div class="guia col-12 col-sm-12 col-md-12 columna">
            <div class="titulo d-flex justify-content-center ">
              <p>¡Bienvenido!</p>
              <br>
            </div>
            <div class="texto2 row columna d-flex justify-content-start pl-2 pt-5">
              <div class=" col-12 col-sm-12 col-md-12">
                <p>Para iniciar sesión debes:</p>
                <p>1. Ingresar el Nit de la empresa</p>
                <p>2. Ingresar código usuario registrado en el sistema.</p>
                <p>3. Ingresar la contraseña.</p>
                <p>4. Finalmente, clic al botón INICIAR SESIÓN.</p>
              </div>
              <div class="row  ">
                <div class="imgGuia columna col-12 col-sm-12 col-md-10 d-flex justify-content-end ">
                  <img src="../../../../assets/images/images/presentation.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<a id="btnmain" href="/main"></a>